<template>
    <div class="wrap">
        <div style="width:100%;margin:20px 0;">
            <el-form ref="form" :model="sizeForm" label-width="100px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="老人姓名" prop='cusId'>
                            <el-select v-model="sizeForm.cusId" placeholder="全部" ref="selectCh">
                                <template v-for="item in oldManList">
                                    <el-option :label="item.cusName" :value="item.cusId"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="服务类型">
                            <el-select v-model="sizeForm.type" placeholder="全部">
                                <el-option label="居家服务" value=1></el-option>
                                <el-option label="机构" value=2></el-option>
                                <el-option label="适老化改造" value=3></el-option>
                                <el-option label="家庭床位" value=4></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item size="large">
                    <el-button type="primary" @click="onSubmit('sizeForm')">立即查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>
        <div style="width:80%;margin:0 10%;">
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="cusname"
                        label="老人姓名"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="relationName"
                        label="联系人"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="relationPhone"
                        label="预约电话">
                </el-table-column>
                <el-table-column
                        prop="serviceAddress"
                        label="地址">
                </el-table-column>
                <el-table-column
                        prop="subscribeTime"
                        label="预约时间">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "service",
        data() {
            return {
                expireTimeOption: {
                    disabledDate(date) {
                        return date.getTime() <= Date.now();
                    }
                },
                userInfo: {
                    id: "",
                    username: "7777",
                    avatar: "",
                },
                username: "",
                dialogVisible: false,
                sizeForm: {},
                sizeFormRules:{},
                tableData: [],
                oldManList:[],
            }
        },
        created(){
            const userInfo = localStorage.getItem("userInfo");
            if (userInfo != null) {
                this.userInfo = JSON.parse(userInfo);
            }
            this.init();
        },
        methods: {
            init(){
                const uid = this.userInfo.id;
                this.$axios
                    .get("/gw/user/customer/list/1/"+uid, {
                        params: {
                            // customerName: this.searchForm.name,
                            // customerName: this.current,
                            // phone: this.size,
                            // state:''
                        },
                    })
                    .then((res) => {
                        this.oldManList = res.data.data.records;
                    });
            },
            onSubmit(form){

                this.$axios
                    .get("/wx/service/order/list/"+this.sizeForm.cusId+"/"+this.sizeForm.type)
                    .then((res) => {
                        this.oldManList = res.data.data.records;
                    });
            },
        },
    };
</script>

<style scoped>


    .wrap {
        height: 7.1875rem /* 115px -> 7.1875rem */;
        width: 100%;
    }

    .header-left {
        float: left;
        width: 18.75rem /* 300px -> 18.75rem */;
        height: 100%;
        margin-left: 15.625rem /* 250px -> 15.625rem */;
        color: #000;
    }

    .address {
        float: left;
    }

    .header-right-line {
        float: right;
        color: #000;
        width: 9.375rem /* 150px -> 9.375rem */;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .header-right {
        float: right;
        color: #000;
        width: 10rem /* 160px -> 10rem */;
        margin-right: 13.75rem /* 220px -> 13.75rem */;
    }

    .login {
        float: left;
        width: 5rem /* 80px -> 5rem */;
        line-height: 7.1875rem /* 115px -> 7.1875rem */;
        height: 7.1875rem /* 115px -> 7.1875rem */;
    }

    .login:hover {
        height: 7rem /* 112px -> 7rem */;
        border-bottom: 3px solid #e6a23c;
    }

    .registered {
        float: left;
        width: 5rem /* 80px -> 5rem */;
        line-height: 7.1875rem /* 115px -> 7.1875rem */;
        height: 7.1875rem /* 115px -> 7.1875rem */;
    }

    .registered:hover {
        height: 7rem /* 112px -> 7rem */;
        border-bottom: 3px solid #f77f00;
    }

    .el-main {
        color: #333;
        padding: 0;
        width: 100%;
    }
</style>
